import React, { useEffect, useState } from "react";
import EndComponent from "./EndComponent";

const EndEngine = ({ config }) => {

    return (
        <EndComponent config={config} />
    );
};

export default EndEngine;
